<template>
  <validation-observer
    ref="scholarshipLevelMinimumSaveFormRef"
    #default="{invalid}"
  >
    <b-modal
      id="scholarshipLevelMinimumSaveModal"
      body-class="position-static"
      centered
      :title="isCreated ? 'Thêm mức học bổng tối thiểu' : 'Cập nhật mức học bổng tối thiểu'"
      @show="onShow"
      @hide="onHide"
      :no-close-on-backdrop="true"
    >
      <b-form>
        <b-form-group label-for="name">
          <template v-slot:label>
            Tên mức học bổng tối thiểu <span class="text-danger">*</span>
          </template>
          <validation-provider
            #default="{ errors }"
            name="Tên trợ cấp sư phạm"
            rules="required"
          >
            <b-form-input
              id="name"
              v-model="targetScholarshipLevelMinimum.name"
              name="name"
              placeholder="Nhập tên mức học bổng tối thiểu"
              :state="getElementState(errors)"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        <b-form-group
          label="Năm học"
          label-for="yearId"
        >
          <template v-slot:label>
            Năm học <span class="text-danger">*</span>
          </template>
          <validation-provider
            #default="{ errors }"
            name="Tên trợ cấp sư phạm"
            rules="required"
          >
            <v-select
              id="yearId"
              v-model="targetScholarshipLevelMinimum.yearId"
              label="name"
              :options="years"
              :reduce="option => option.id"
              :clearable="false"
              :state="getElementState(errors)"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        <b-form-group label-for="minCost">
          <template v-slot:label>
            Số tiền <span class="text-danger">*</span>
          </template>
          <validation-provider
            #default="{ errors }"
            name="Số tiền"
            rules="required"
          >
            <b-form-input
              id="minCost"
              v-model="targetScholarshipLevelMinimum.minCost"
              name="minCost"
              placeholder="Nhập Số tiền"
              :state="getElementState(errors)"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        <b-form-group label-for="status">
          <template v-slot:label>
            Trạng thái <span class="text-danger">*</span>
          </template>
          <validation-provider
            #default="{ errors }"
            name="Trạng thái"
            rules="required"
          >
            <v-select
              v-model="targetScholarshipLevelMinimum.status"
              :options="statusOptions"
              :reduce="option => option.value"
            />
            <b-form-invalid-feedback :state="getElementState(errors)">
              {{ errors[0] }}
            </b-form-invalid-feedback>
          </validation-provider>
        </b-form-group>
      </b-form>
      <template #modal-footer>
        <div class="w-100 d-flex justify-content-end">
          <b-button
            v-show="isCreated"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-1"
            :disabled="invalid"
            @click="onSave"
          >
            <span class="text-right">
              <feather-icon icon="CheckIcon" /> Lưu và tiếp tục
            </span>
          </b-button>

          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-1"
            :disabled="invalid"
            @click="onSave('hide')"
          >
            <span class="text-right">
              <feather-icon icon="CheckIcon" /> Lưu lại
            </span>
          </b-button>

          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-secondary"
            @click="$bvModal.hide('scholarshipLevelMinimumSaveModal')"
          >
            <span class="text-right">
              <feather-icon icon="XIcon" /> Hủy
            </span>
          </b-button>
        </div>
      </template>
      <b-overlay
        no-wrap
        variant="white"
        spinner-variant="primary"
        blur="0"
        opacity=".75"
        rounded="sm"
        :show="isLoading"
      />
    </b-modal>
  </validation-observer>
</template>

<script>
import {
  BForm, BFormGroup, BFormInput, BModal, BOverlay, BFormInvalidFeedback, BButton,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from '@validations'
import vSelect from 'vue-select'
import { mapActions, mapGetters } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import api from './api'

export default {
  name: 'ScholarshipLevelMinimumSave',
  components: {
    BFormGroup,
    BFormInput,
    BModal,
    BForm,
    BOverlay,
    BFormInvalidFeedback,
    BButton,
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: {
    scholarshipLevelMinimum: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      isLoading: false,
      targetScholarshipLevelMinimum: {
        id: null,
        name: '',
        code: '',
        status: 1,
        minCost: null,
        yearId: null,
      },
      statusOptions: [
        { value: 1, label: 'Đang hoạt động' },
        { value: 0, label: 'Không hoạt động' },
      ],
      years: [],
      required,
    }
  },
  computed: {
    ...mapGetters({
    }),
    isCreated() {
      return !this.scholarshipLevelMinimum
    },
    currentYear() {
      return new Date().getFullYear()
    },
  },
  methods: {
    ...mapActions({
    }),
    getElementState(errors) {
      return errors.length > 0 ? false : null
    },
    async onShow() {
      this.years = await api.getYears()
      if (this.years.length > 0) {
        const found = this.years.find(year => year.endYear === this.currentYear)
        this.targetScholarshipLevelMinimum.yearId = found ? found.id : this.years[0].id
      }
      if (this.scholarshipLevelMinimum) {
        this.targetScholarshipLevelMinimum = { ...this.scholarshipLevelMinimum }
      }
    },
    onHide() {
      this.$refs
        .scholarshipLevelMinimumSaveFormRef
        .reset()
      this.targetScholarshipLevelMinimum = {
        id: null,
        name: '',
        code: '',
        status: 1,
        orderNo: 1,
      }
    },
    async onSave(type = null) {
      const valid = this.$refs
        .scholarshipLevelMinimumSaveFormRef
        .validate()
      if (valid) {
        this.isLoading = true
        try {
          const response = this.isCreated
            ? await api.create(this.targetScholarshipLevelMinimum)
            : await api.update(this.targetScholarshipLevelMinimum)
          if (response) {
            const { isSuccessful, message } = response
            if (isSuccessful) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: message,
                  icon: 'CheckIcon',
                  variant: 'success',
                },
              })
              if (type === 'hide') {
                this.$bvModal.hide('scholarshipLevelMinimumSaveModal')
              }
              this.$emit('succeed')
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: message,
                  icon: 'XCircleIcon',
                  variant: 'danger',
                },
              })
            }
          }
        } catch (e) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `[${e.code}] ${e.message}`,
              icon: 'XCircleIcon',
              variant: 'danger',
            },
          })
        } finally {
          this.isLoading = false
        }
      }
    },
  },
}
</script>
